import template from './contract-details.html';
import controller from './contract-details.controller';

let contractDetailsComponent = {
  restrict: 'E',
  bindings: {
    contractId: '<'
  },
  template,
  controller
};

export default contractDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/contract-details/contract-details.component.js